"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sqlFields = exports.defaultVegaSchema = void 0;

exports.defaultVegaSchema = function () {
  return {
    $schema: "https://vega.github.io/schema/vega/v3.json",
    data: [],
    legend: [],
    config: {},
    signals: [{
      name: "width",
      value: "",
      on: [{
        events: {
          source: "window",
          type: "resize"
        },
        update: "containerSize()[0]*0.95"
      }]
    }, {
      name: "height",
      value: "",
      on: [{
        events: {
          source: "window",
          type: "resize"
        },
        update: "containerSize()[1]*0.95"
      }]
    }],
    autosize: {
      type: "fit",
      contains: "padding"
    },
    scales: [],
    axes: [],
    marks: []
  };
};

exports.sqlFields = {
  value: "x",
  category: "y",
  color: "color"
};
exports["default"] = {
  defaultVegaSchema: exports.defaultVegaSchema,
  sqlFields: exports.sqlFields
};